export default function guest({ next, store }) {
  if (store.state.auth.isAuthenticated) {
    return next({
      name: 'Home'
    })
  }
  return next()
}
